import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;
}

@Injectable({
  providedIn: 'root',
})
export class ConfirmExitGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(
    component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // If nextState is defined, it's an internal navigation within the app.
    // In this case, we want to allow navigation without confirmation.
    if (nextState && nextState.url != '/login') {
      //console.log(nextState);
      return true;
    }

    // If nextState is not defined, it implies the user is leaving the application
    // (e.g., closing the tab, navigating to an external site).
    // In this case, we trigger the component's canDeactivate logic.
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
/*
export const confirmExitGuard: CanDeactivateFn<unknown> = (component, currentRoute, currentState, nextState) => {
  return true;
};
*/
